import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { SpiritoryWebEndpoints } from '@/types/api/api-v2';

export default async function doNewVerificationEmailWithAuth(captcha: string) {
  try {
    await spiritoryWebApi.get(
      ('/auth/sign-up/credentials/email-verification/resend?captcha=' +
        captcha) as SpiritoryWebEndpoints,
      undefined
    );
  } catch (err) {
    throw err;
  }
}
